import { DiscussionImageCarousel } from '@/components/discussion-image-carousel/discussion-image-carousel';

import { makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    // backgroundColor: '#666',
  },
}));

//   const Transition = forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
//   });

export const DiscussionImageDashboard = ({
  discussionId,
}: {
  discussionId: string;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <DiscussionImageCarousel discussionId={discussionId} />
    </div>
  );
};
DiscussionImageDashboard.displayName = 'DiscussionImageDashboard';
